import React from "react"
import * as AppConstants from "../../utility/AppConstants"
import * as Utility from "../../utility/Utility"
import 'Css/table.css'

function HeaderTotali(props: any) {
    return (
        <React.Fragment>
            <tr>
                <th style={{width:'20rem'}}>
                    {Utility.getValoreHeader(props.codIsa, props.macroarea)}{" "}
                </th>
                <th className="th-statistiche">
                    {AppConstants.TITLE_PERSONE_FISICE}
                </th>
                <th className="th-statistiche">
                    {AppConstants.TITLE_SOCIETA_PERSONE}
                </th>
                <th className="th-statistiche div-inline">
                    {AppConstants.TITLE_SOC_CAPITALI_ENTI_NON_COMMERCIALI}
                </th>
                <th className="th-statistiche">{AppConstants.TITLE_TOTALE}</th>
            </tr>
        </React.Fragment>
    )
}
export default HeaderTotali
